import { render, staticRenderFns } from "./right-plan-info.vue?vue&type=template&id=1f14a638&scoped=true&"
import script from "./right-plan-info.vue?vue&type=script&lang=js&"
export * from "./right-plan-info.vue?vue&type=script&lang=js&"
import style0 from "./right-plan-info.vue?vue&type=style&index=0&id=1f14a638&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f14a638",
  null
  
)

export default component.exports